import { forwardRef, useId, type InputHTMLAttributes } from 'react';
import { formStyles } from '@utils/formStyles';

interface FormCheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: string;
    error?: string;
    helpText?: string;
    labelClassName?: string;
}

const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
    ({ label, error, helpText, className = '', labelClassName = '', id, ...rest }, ref) => {
        const generatedId = useId();
        const inputId = id ?? generatedId;

        // Use the color constants but in Tailwind format
        const checkboxClasses = `h-4 w-4 rounded border-[#444] bg-[#333] text-[#0275d8] focus:ring-[#0275d8] ${error ? 'border-red-500' : ''} ${className}`;

        return (
            <div className="flex items-center">
                <input className={checkboxClasses} id={inputId} ref={ref} type="checkbox" {...rest} />
                {label && (
                    <label className={`ml-2 text-sm font-medium ${labelClassName}`} htmlFor={inputId}>
                        {label}
                    </label>
                )}
                <div className="flex flex-col ml-1">
                    {helpText && <div className={formStyles.helpText}>{helpText}</div>}
                    {error && <div className={formStyles.errorText}>{error}</div>}
                </div>
            </div>
        );
    }
);

FormCheckbox.displayName = 'FormCheckbox';

export default FormCheckbox;
